import AppBarAwareDrawer from 'Components/AppBarAwareDrawer'
import { DRAWER_WIDTH } from 'Util/constants'
import { styled } from '@mui/material/styles'
import type { CSSObject } from '@mui/system'

const openedMixin = (): CSSObject => ({
  width: DRAWER_WIDTH,
  overflowX: 'hidden',
  borderRight: 0
})

const StyledDrawer = styled(AppBarAwareDrawer, { shouldForwardProp: prop => prop !== 'open' })(
  ({ open }) => ({
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(),
      '& .MuiDrawer-paper': {
        ...openedMixin(),
        borderRight: '1px solid rgba(0, 0, 0, 0.08)'
      }
    })
  })
)

export default StyledDrawer
